export default {
  white: '#FFF',
  hover: '#BBE9F1',
  teal: '#33FFF0',
  grey: '#A0A0A0',
  black: '#080707',
  lightBlue: '#BBE9F1',
  strongBlue: '#0070D2',
  transparent: '#RRGGBBAA',
  darkgrey: '#6C6C6C',
  calicite: '#044561',
  eerieBlack: '#1B1B1B',
  searchGrey: '#706E6B',
  iconHover: '#1C445E',
  lightGrey: '#C9C9C9',
  slateBlue: '#54698D',
  bannerBlue: '#085caa',
  disabledGrey: '#A19F9D',
};
